/* Pat Kay — Store: category filter, 3-up grid, pagination. Vanilla port of prototype store-app.jsx. */

(function () {
  var layout = document.getElementById('pk-store');
  if (!layout) return;

  var PRODUCTS = JSON.parse(document.getElementById('pk-store-data').textContent);
  var PER_PAGE = 15;
  var HASH_CATS = { '#courses': 'Courses', '#ebooks': 'eBooks', '#presets': 'Lightroom Presets', '#luts': 'LUTs', '#wallpapers': 'Wallpapers' };

  // keep the design's shelf order regardless of collection sort
  var CAT_RANK = { 'Courses': 0, 'eBooks': 1, 'Lightroom Presets': 2, 'LUTs': 3, 'Wallpapers': 4, 'Gift': 5 };
  function rank(cat) { return CAT_RANK[cat] === undefined ? 9 : CAT_RANK[cat]; }
  PRODUCTS = PRODUCTS.map(function (p, i) { return { p: p, i: i }; })
    .sort(function (a, b) {
      var r = rank(a.p.cat) - rank(b.p.cat);
      return r !== 0 ? r : a.i - b.i;
    })
    .map(function (x) { return x.p; });

  var grid = document.getElementById('pk-product-grid');
  var paginationEl = document.getElementById('pk-pagination');
  var catMenu = layout.querySelector('.cat-menu');
  var hoverInd = catMenu.querySelector('.cat-indicator');
  var activeInd = catMenu.querySelector('.cat-active-indicator');
  var catBtns = Array.prototype.slice.call(catMenu.querySelectorAll('.cat-link'));

  // Real collection URLs (admin nav links to /collections/ebooks etc.) land on
  // this same template — derive the category from the handle, hash still wins.
  var PATH_CATS = { 'courses': 'Courses', 'ebooks': 'eBooks', 'books': 'eBooks', 'lightroom-presets': 'Lightroom Presets', 'presets': 'Lightroom Presets', 'luts': 'LUTs', 'video-luts': 'LUTs', 'wallpapers': 'Wallpapers' };
  var pathHandle = (location.pathname.match(/\/collections\/([^\/?#]+)/) || [])[1];
  var category = HASH_CATS[location.hash.toLowerCase()] || PATH_CATS[pathHandle] || 'All products';
  var page = 1;

  function filtered() {
    return category === 'All products' ? PRODUCTS : PRODUCTS.filter(function (p) { return p.cat === category; });
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function renderCard(p) {
    var card = el('div', 'p-card');
    var cover = el('div', 'p-cover');
    if (p.image) {
      var img = document.createElement('img');
      img.src = p.image;
      img.alt = p.title;
      img.loading = 'lazy';
      cover.appendChild(img);
    } else {
      cover.appendChild(el('div', 'p-cover-label', 'cover'));
    }
    card.appendChild(cover);
    var meta = el('div', 'p-meta');
    if (p.category) meta.appendChild(el('div', 'p-cat', p.category));
    meta.appendChild(el('div', 'p-title', p.title));
    if (p.price) meta.appendChild(el('div', 'p-price', p.price));
    card.appendChild(meta);
    var arrow = el('span', 'p-arrow', '→');
    arrow.setAttribute('aria-hidden', 'true');
    card.appendChild(arrow);
    if (p.href) {
      card.addEventListener('click', function () { location.href = p.href; });
    }
    return card;
  }

  function arrowSvg(dir) {
    var points = dir === 'left' ? '15 18 9 12 15 6' : '9 18 15 12 9 6';
    return '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" style="display:block"><polyline points="' + points + '"></polyline></svg>';
  }

  // The rail runs down the side on desktop and along the top once it collapses.
  // Both orientations get the same marks; only the axis changes.
  var OVERHANG = 15;
  function isHorizontal() { return getComputedStyle(catMenu).flexDirection === 'row'; }
  function placeMark(mark, btn) {
    if (!mark || !btn) return;
    if (isHorizontal()) {
      // clamp at 0: the rail is a scroll container, so a negative offset would be clipped
      var left = Math.max(0, btn.offsetLeft - OVERHANG);
      var right = btn.offsetLeft + btn.offsetWidth + OVERHANG;
      mark.style.top = '0px';
      mark.style.height = '3px';
      mark.style.left = left + 'px';
      mark.style.width = (right - left) + 'px';
    } else {
      mark.style.left = '0px';
      mark.style.width = '3px';
      mark.style.top = (btn.offsetTop - OVERHANG) + 'px';
      mark.style.height = '55px';
    }
  }
  function placeActiveIndicator() {
    placeMark(activeInd, catMenu.querySelector('.cat-link.active'));
  }

  function render() {
    var list = filtered();
    var pageCount = Math.max(1, Math.ceil(list.length / PER_PAGE));
    if (page > pageCount) page = pageCount;
    var shown = list.slice((page - 1) * PER_PAGE, page * PER_PAGE);

    grid.innerHTML = '';
    shown.forEach(function (p, i) {
      var card = renderCard(p);
      // quick, tight stagger so a filtered set reveals in sequence rather than all at once
      card.style.animationDelay = (i * 30) + 'ms';
      grid.appendChild(card);
    });

    catBtns.forEach(function (b) { b.classList.toggle('active', b.dataset.cat === category); });
    placeActiveIndicator();

    paginationEl.innerHTML = '';
    paginationEl.hidden = pageCount <= 1;
    if (pageCount > 1) {
      var prev = el('button', 'page-arrow');
      prev.type = 'button';
      prev.setAttribute('aria-label', 'Previous page');
      prev.disabled = page === 1;
      prev.innerHTML = arrowSvg('left');
      prev.addEventListener('click', function () { goPage(page - 1); });
      paginationEl.appendChild(prev);

      for (var n = 1; n <= pageCount; n++) {
        (function (n) {
          var b = el('button', 'page-num' + (n === page ? ' active' : ''), String(n));
          b.type = 'button';
          b.addEventListener('click', function () { goPage(n); });
          paginationEl.appendChild(b);
        })(n);
      }

      var next = el('button', 'page-arrow');
      next.type = 'button';
      next.setAttribute('aria-label', 'Next page');
      next.disabled = page === pageCount;
      next.innerHTML = arrowSvg('right');
      next.addEventListener('click', function () { goPage(page + 1); });
      paginationEl.appendChild(next);
    }

    updateIceberg();
  }

  function goPage(n) {
    page = n;
    render();
    var y = layout.getBoundingClientRect().top + window.scrollY - 110;
    window.scrollTo({ top: y, behavior: 'smooth' });
  }

  function pick(cat) {
    category = cat;
    page = 1;
    render();
    centerActiveTab();
  }

  // ----- Iceberg: fade the horizontal rail's edges when the tabs overflow -----
  function updateIceberg() {
    var max = catMenu.scrollWidth - catMenu.clientWidth;
    catMenu.classList.toggle('overflowing', max > 1);
    catMenu.classList.toggle('can-left', catMenu.scrollLeft > 1);
    catMenu.classList.toggle('can-right', catMenu.scrollLeft < max - 1);
  }
  function centerActiveTab() {
    var btn = catMenu.querySelector('.cat-link.active');
    if (!btn || catMenu.scrollWidth <= catMenu.clientWidth) return;
    var target = btn.offsetLeft - (catMenu.clientWidth - btn.offsetWidth) / 2;
    catMenu.scrollTo({ left: Math.max(0, target), behavior: 'smooth' });
  }
  catMenu.addEventListener('scroll', updateIceberg, { passive: true });
  window.addEventListener('resize', function () {
    updateIceberg();
    placeActiveIndicator();   // the rail may have flipped orientation
  }, { passive: true });

  // ----- Grab-to-scroll with the mouse (touch already scrolls the rail natively) -----
  var dragging = false, dragMoved = false, dragStartX = 0, dragStartScroll = 0;
  catMenu.addEventListener('pointerdown', function (e) {
    if (e.pointerType !== 'mouse') return;                  // let touch scroll on its own
    if (catMenu.scrollWidth <= catMenu.clientWidth) return; // nothing to drag
    dragging = true;
    dragMoved = false;
    dragStartX = e.clientX;
    dragStartScroll = catMenu.scrollLeft;
    catMenu.classList.add('grabbing');
  });
  window.addEventListener('pointermove', function (e) {
    if (!dragging) return;
    var dx = e.clientX - dragStartX;
    if (Math.abs(dx) > 3) dragMoved = true;
    catMenu.scrollLeft = dragStartScroll - dx;
  });
  window.addEventListener('pointerup', function () {
    if (!dragging) return;
    dragging = false;
    catMenu.classList.remove('grabbing');
    setTimeout(function () { dragMoved = false; }, 0);      // clear after any click has fired
  });
  // swallow the click that ends a drag so it doesn't switch category
  catMenu.addEventListener('click', function (e) {
    if (dragMoved) { e.preventDefault(); e.stopPropagation(); }
  }, true);

  // ----- Category menu: hover indicator (grey) + persistent active indicator (ink) -----
  // only wire hover on real pointers — touch fires a synthetic mouseenter on tap
  var canHover = !window.matchMedia || window.matchMedia('(hover: hover)').matches;
  catBtns.forEach(function (btn) {
    // the trailing Prints entry is a link out, not a filter — it carries no data-cat
    if (btn.dataset.cat) {
      btn.addEventListener('click', function () { pick(btn.dataset.cat); });
    }
    if (!canHover) return;
    btn.addEventListener('mouseenter', function () {
      if (!catMenu.classList.contains('indicator-on')) {
        // first hover: place instantly, no slide
        hoverInd.style.transition = 'none';
        placeMark(hoverInd, btn);
        void hoverInd.offsetHeight;
        hoverInd.style.transition = '';
        catMenu.classList.add('indicator-on');
      } else {
        placeMark(hoverInd, btn);
      }
    });
  });
  if (canHover) {
    catMenu.addEventListener('mouseleave', function () { catMenu.classList.remove('indicator-on'); });
  }

  // hash quick-links (menu/search takeover) keep working while already on the store
  window.addEventListener('hashchange', function () {
    var cat = HASH_CATS[location.hash.toLowerCase()];
    if (cat && cat !== category) pick(cat);
  });

  render();
})();
